import { Outlet } from "react-router-dom";
import { Header, Footer, UserChat} from "../../components";
import { useRef, useState } from "react";
import { useIsVisible } from "../../utilities/useIsVisible";
import { Button } from "react-bootstrap";

export default function Layout(props) {
  // general layout
  // props:
  //      admin (boolean): if true, do not show the fixed chat window, else show it

  const [chatExpanded, setChatExpanded] = useState(false);

  // scroll up button: don't display if can see header
  const ref = useRef(); 
  const headerIsVisible = useIsVisible(ref); 

  const toggleChatWindow = () => {
    setChatExpanded((prevValue) => !prevValue);
  };

  return (
    <>
      <div className="body-container">
        <div ref={ref}>
        <Header />
        </div>
        <div className="main-content">
          <Outlet />
          {!props.admin && (
            <UserChat
              toggleChatWindow={toggleChatWindow}
              chatExpanded={chatExpanded}
            />
          )}
        </div>
        <div className="footer">
          <Footer toggleChatWindow={toggleChatWindow} />
        </div>
        {/* Scroll up button */}
       {!headerIsVisible && <Button variant="none" onClick={() => window.scrollTo(0,0)} className="scrollToTopButton"><i className="bi bi-arrow-up-circle scrollToTopIcon"></i></Button>}
      </div>
    </>
  );
}
